export default {
  people: [],
  person: undefined,
  search: '',
};
